import { createFileRoute } from "@tanstack/react-router";
import { CheckupPage } from "@/modules/checkup/presentation/pages/CheckupPage";

export const Route = createFileRoute("/_authenticated/checkup")({
  component: CheckupPage,
});
